<template>
    <base-material-card :icon="resource.icon" :title="title">
        <va-list :filters="filters">
            <va-data-table :fields="fields"> </va-data-table>
        </va-list>
    </base-material-card>
</template>

<script>
export default {
    props: ["resource", "title"],
    data() {
        return {
            filters: [
                "id",
                { source: "created_at", type: "date" },
                { source: "updated_at", type: "date" },
            ],
            fields: [
                { source: "id", sortable: true },
                { source: "created_at", type: "date", sortable: true },
                { source: "updated_at", type: "date", sortable: true },
            ],
        };
    },
};
</script>
